import { getLogLevelName, Message, ROARR } from "roarr";
import App from "./App.svelte";

ROARR.write = (messageStr) => {
    const message: Message = JSON.parse(messageStr);

    const time = new Date(message.time);
    const log = `#${message.sequence} [${time.toLocaleString()}]: ${
        message.message
    }`;

    const logLevelName = getLogLevelName(message.context.logLevel as number);
    switch (logLevelName) {
        case "trace":
            console.trace(log);
            break;
        case "debug":
            console.debug(log);
            break;
        case "info":
            console.info(log);
            break;
        case "warn":
            console.warn(log);
            break;
        case "error":
        case "fatal":
            console.error(log);
            break;
    }
};

const app = new App({
    target: document.body,
    /*props: {
		name: 'world'
	}*/
});

export default app;
